export const AUTH_CONFIG = {
  domain: 'sca.eu.auth0.com',
  clientID: 'oOrzV3EQnJPD0mHu5LdoJ6au4G2cwAVE',
  // redirectUri: 'http://localhost:8080/auth-callback',
  redirectUri: `${location.origin}/auth-callback`,

  // https://community.auth0.com/t/access-token-too-short-jwt-malformed/9169/5
  // audience: 'https://sca.eu.auth0.com/userinfo',
  audience: 'https://bct.app.algoryx.se',
  responseType: 'token id_token',
  scope: 'openid email',
};



// WEBPACK FOOTER //
// ./src/auth/auth0-config.ts